import { render, staticRenderFns } from "./costDetailsTable.vue?vue&type=template&id=a9555076&scoped=true&"
import script from "./costDetailsTable.vue?vue&type=script&lang=js&"
export * from "./costDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./costDetailsTable.vue?vue&type=style&index=0&id=a9555076&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9555076",
  null
  
)

export default component.exports